import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

export const Trigger = styled.button<{ $placeholder: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    height: 44px;
    padding: 0 10px 0 14px;
    border: 1px solid ${colors.fieldBorder};
    border-radius: ${radii.base};
    background: ${colors.surface};
    font-family: inherit;
    font-size: 15px;
    color: ${({ $placeholder }) => ($placeholder ? colors.textSecondary : colors.textPrimary)};
    text-align: left;
    cursor: pointer;

    &:focus-visible {
        outline: none;
        border-color: ${colors.primary};
    }

    &:disabled {
        opacity: 0.6;
        cursor: default;
    }

    svg {
        flex: 0 0 auto;
        font-size: 20px;
        color: ${colors.textSecondary};
    }
`;

export const TriggerLabel = styled.span`
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Panel = styled.div<{ $inSheet: boolean }>`
    display: flex;
    flex-direction: column;
    /* В поповере ширину задаёт якорь, в листе — сам лист. */
    width: ${({ $inSheet }) => ($inSheet ? "100%" : "auto")};
    padding: ${({ $inSheet }) => ($inSheet ? "0 0 8px" : "10px 10px 6px")};
`;

export const Options = styled.div<{ $inSheet: boolean }>`
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    /* Список скроллится внутри себя: каталог внешнего меню бывает на сотни позиций. */
    max-height: ${({ $inSheet }) => ($inSheet ? "50vh" : "260px")};
    overflow-y: auto;
`;

export const Option = styled.button<{ $selected: boolean; $inSheet: boolean }>`
    display: block;
    width: 100%;
    min-height: ${({ $inSheet }) => ($inSheet ? "52px" : "40px")};
    padding: ${({ $inSheet }) => ($inSheet ? "8px 10px" : "8px 10px")};
    border: none;
    border-radius: ${radii.small};
    background: ${({ $selected }) => ($selected ? colors.infoBg : "transparent")};
    font-family: inherit;
    font-size: 15px;
    color: ${colors.textPrimary};
    text-align: left;
    cursor: pointer;

    &:hover {
        background: ${({ $selected }) => ($selected ? colors.infoBg : colors.segmentBg)};
    }
`;

export const ClearOption = styled(Option)`
    color: ${colors.textSecondary};
`;

export const Message = styled.div`
    padding: 12px 10px;
    font-size: 14px;
    color: ${colors.textSecondary};
`;

// Якорь догрузки: видимым он становится, когда список долистали до конца.
export const LoadMoreAnchor = styled.div`
    height: 1px;
`;

export const PopoverPaper = {
    borderRadius: radii.base,
    boxShadow: shadows.panel,
};
